import React from "react";
import { Table } from "../../ui/Table";
import PropTypes from "prop-types";
import { FormatInt } from "../../../utils/FormatData";
const SummaryMessagesByPartner = ({ data = [], loading }) => {
  const columns = [
    {
      Header: "Partner",
      accessor: "vc_partner",
    },
    {
      Header: "Enviados",
      accessor: "i_send",
      Cell: (rowData) => {
        let value = rowData.row.original.i_send;
        return FormatInt(value);
      },
    },
    {
      Header: "Por Procesar",
      accessor: "i_pending",
      Cell: (rowData) => {
        let value = rowData.row.original.i_pending;
        return FormatInt(value);
      },
    },
    {
      Header: "Respuestas",
      accessor: "i_responses",
      Cell: (rowData) => {
        let value = rowData.row.original.i_responses;
        return FormatInt(value);
      },
    },
    {
      Header: "Inválidos",
      accessor: "i_invalid",
      Cell: (rowData) => {
        let value = rowData.row.original.i_invalid;
        return FormatInt(value);
      },
    },
  ];
  return (
    <div className="p-4 bg-white rounded-lg shadow-md">
      <Table
        title="Mensajes por procesar API"
        data={data}
        columns={columns}
        loading={loading}
        config={{
          search: true,
          perPage: 10,
          pageSize: 10,
          footer: true,
        }}
        rowRule={(row) => {
          const raw = Number(row.original.i_pending);
          const abs = Math.abs(raw);
          if (abs > 0) {
            return "bg-yellow-50 text-yellow-700";
          }
        }}
      />
    </div>
  );
};

SummaryMessagesByPartner.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
};

export default SummaryMessagesByPartner;
